<!-- 
    编辑号码
    jay 2020-02-28
 -->
<template>
  <div class="childRoute-wrapper">
    <van-nav-bar
      :title="$t('recharge.editNumber')"
      :fixed="true"
      left-arrow
      @click-left="navbarback"
    >
      <span slot="right" @click="userMobilesEdit">
        {{ $t("common.save") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <van-cell-group :border="false" class="mobile-input">
        <van-field
          :border="false"
          v-model="remark"
          :placeholder="$t('recharge.clickAddNote')"
        />
        <van-field
          :border="false"
          type="tel"
          v-model="mobile"
          :placeholder="$t('common.enterMobile')"
        />
      </van-cell-group>
      <div class="button-wrap">
        <van-button block type="primary" @click="userMobilesDelete">
          {{ $t("recharge.deleteNumber") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    },
    editMobileFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    },
    editInfo: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
      remark: "",
      mobile: ""
    };
  },
  created() {},
  mounted() {
    if (this.editInfo.id) {
      this.mobile = this._phoneFormat(this.editInfo.mobile);
      this.remark = this.editInfo.name;
    }
  },
  computed: {},
  methods: {
    navbarback() {
      //返回上一页
      this.$emit("update:editMobileFlag", false);
    },
    userMobilesEdit() {
      // 编辑电话簿手机号
      let vm = this;
      //先判断手机号是否为空
      if (vm.mobile == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return;
      }
      let flag = true;
      if (
        vm.editInfo.mobile.replace(/\s/g, "") == vm.mobile.replace(/\s/g, "")
      ) {
        flag = false;
      }
      if (!flag) {
        //存在该号码，判断是否修改了备注
        if (vm.remark == vm.editInfo.name) {
          vm.$toast(vm.$t("recharge.mobileEditFailed"));
          return;
        }
      }
      let params = {};
      params.mobile = vm.mobile.replace(/\s/g, "");
      params.name = vm.remark;
      params.mobile_id = vm.editInfo.id;
      vm.$post("/app/user/userMobilesEdit", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("userMobilesEdit", res);
        vm.collapseVal = "";
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$emit("changeMobile");
          vm.navbarback();
        }
      });
    },
    userMobilesDelete() {
      // 删除电话簿手机号
      let vm = this;
      vm.$dialog
        .confirm({
          title: vm.$t("recharge.sureDeleteNumber"),
          beforeClose(action, done) {
            if (action === "confirm") {
              let params = {};
              params.mobile_id = vm.editInfo.id;
              vm.$post("/app/user/userMobilesDelete", params, {
                alert: true,
                loading: true
              }).then(res => {
                console.log("userMobilesDelete", res);
                vm.$toast(res.msg);
                if (res.code == 0) {
                  //删除之后返回去
                  vm.navbarback();
                  vm.$emit("changeMobile");
                  //弹窗关闭
                  done();
                } else {
                  //弹窗不关闭
                  done(false);
                }
              });
            } else {
              done();
            }
          }
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.mobile-input {
  padding: 0 22px;
  margin-top: 12px;
  .van-cell {
    padding: 0;
    height: 44px;
    align-items: center;
    border-bottom: 1.1px solid #e4e4e4;
  }
}
</style>
